// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card--checked h3.card__header{text-decoration:line-through!important}.summary-card.card--readwrite:hover .card__title{display:block!important}.summary-card .editable table.table-sm p{font-size:small;margin-bottom:0}.summary-card--current_vs_recommended .editable table.table-sm p,.summary-card--supp_vs_ma .editable table.table-sm p{font-size:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
